$(function () {
  $(document).ready(function () {
    let labels = $(".swatch label");

    if (labels.length) {
      console.log(labels);
      labels.each(function () {
        let text = $(this).text();
        let result = text.match(/\(Save [0-9]+%\)/gim);
        if (result) {
          let label = text.replace(result, "").trim();
          let save = result[0].replace("(", "").replace(")", "");

          $(this).html(label + '<span class="save">' + save + "</span>");
        }
      });
    }
  });

  $('.collection-faqs .collection-faq-que').click(function(){
    $(this).siblings('.collection-faq-ans').slideToggle();
    $(this).toggleClass('open');
  });

  /*$('.collection-product-grid .product-list').flickity({
    cellAlign: "center",
    pageDots: false,
    contain: true,
    groupCells: true,
    autoPlay: 2000,
    adaptiveHeight: true
  });*/
  
  $('.product-award-images, .logo-list-section .logo-bar.slider-enabled').flickity({
    cellAlign: "left",
    pageDots: false,
    contain: true,
    autoPlay: 1000,
    adaptiveHeight: true,
    wrapAround: true,
    prevNextButtons: false
  });

  $('.logo-list-section .logo-bar:not(.slider-enabled)').flickity({
    cellAlign: "left",
    pageDots: false,
    contain: true,
    autoPlay: 1000,
    adaptiveHeight: true,
    wrapAround: true,
    prevNextButtons: false,
    watchCSS: true
  });

  $('.product-review-images').flickity({
    pageDots: false,
    contain: true,
    groupCells: true,
    adaptiveHeight: true
  });

  $('.product-content__box').each(function(){
    if($('.product-content__content', this).height() > 300){
      $(this).addClass('show_btn');
    }
  });

  $('.product-content__box .read_more_btn').click(function(){
    $(this).parent('.product-content__box').toggleClass('show-whole');
    $(this).toggleClass('open');
    if($(this).hasClass('open')) $(this).text('Read Less');
    else $(this).text('Read More');
  });
}, false);
